<template>
    <div v-if="mobileCheck">
        <div class="no-data" v-if="!tradesListLength">{{ $t('trade-history0') }}</div>
        <div v-else>
            <div v-if="!showInvoice && !showSOInvoice">
                <div class="mobile-wines-header">
                    <div>{{ $t('trade-history1') }}</div>
                    <div>{{ $t('trade-history2') }}</div>
                    <div>{{ $t('trade-history3') }}</div>
                    <div class="mobile-wines-div-row">{{ $t('wine') }}</div>
                    <div>{{ $t('quantity') }}</div>
                    <div>{{ $t('trade-history4') }}</div>
                    <div>{{ $t('trade-history5') }}</div>
                    <div>{{ $t('trade-history6') }}</div>
                    <div>{{ $t('invoice06') }}</div>
                </div>
                <div class="mobile-wines-body">
                    <div class="mobile-wines-row" v-for="(item, index) in filteredItems" :key="index">
                        <div class="mobile-wines-div">
                            {{ item.date }}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.type}}
                        </div>
                        <div class="mobile-wines-div mobile-wines-div-row">
                            <div class="wine-name">{{ item.wine }}</div>
                        </div>
                        <div class="mobile-wines-div">
                            {{item.quantity}}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.service}}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.total}}
                        </div>
                        <div class="mobile-wines-div" v-on:click="() => { goToInvoiceDetails(item) }">
                            <div class="hyperlink-td">
                                {{item.documentId}}
                                <div class="link-border"></div>
                            </div>
                        </div>
                        <div class="mobile-wines-div">
                            {{item.status}}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="invoice-details-wrapper">
                    <h2 class="mobile-wines-title">{{ $t('my-account-menu9') }}</h2>
                    <div v-if="showSOInvoice">
                        <div class="back-invoice" v-on:click="onBackButtonHandler">
                            <div>{{ $t('back') }}</div>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path d="M0 0h24v24H0z" fill="none"/>
                                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                            </svg>
                        </div>
                        <v-card header-tag="header">
                            <v-container fluid class="container-invoice" v-if="SOInvoiceDetails.invoiceType === 1">
                                <div class="header-part"></div>
                                <div class="logo"></div>
                                <div class="header-info">
                                    <div class="header-info-left">
                                        <div class="header-info-row"><span>SALE ORDER</span></div>
                                        <div class="header-info-row"><span>Client ID:</span>
                                            {{SOSOInvoiceDetails.invoice.userId}}
                                        </div>
                                        <div class="header-info-row"><span>Invoice #:</span>
                                            {{SOInvoiceDetails.invoice.userId}}-SO-{{SOInvoiceDetails.invoice.id}}
                                        </div>
                                        <div class="header-info-row"><span>Invoice date:</span> {{
                                            formatInvoiceDate(SOInvoiceDetails.invoice.createdOn) }}
                                        </div>
                                        <div class="header-info-row"><span>Invoice period:</span> {{
                                            formatInvoiceDate(SOInvoiceDetails.invoice.createdOn, true) }}
                                        </div>
                                        <div class="header-info-row"><span>Page:</span> 1/1</div>
                                    </div>
                                    <div class="header-info-right">
                                        <div class="header-info-row">{{SOInvoiceDetails.address.clientName}}</div>
                                        <div class="header-info-row">{{SOInvoiceDetails.address.address1}}</div>
                                        <div class="header-info-row" v-if="SOInvoiceDetails.address.address2">
                                            {{SOInvoiceDetails.address.address2}}
                                        </div>
                                        <div class="header-info-row">{{SOInvoiceDetails.address.postCode}},
                                            {{SOInvoiceDetails.address.city}}
                                        </div>
                                        <div class="header-info-row">{{SOInvoiceDetails.address.country}}</div>

                                        <div class="header-info-row vat"><strong>Vat Number:</strong>
                                            {{SOInvoiceDetails.address.vatNumber}}
                                        </div>
                                        <div class="header-info-row"><strong>Email:</strong> {{
                                            SOInvoiceDetails.address.email }}
                                        </div>
                                        <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                            {{SOInvoiceDetails.address.phoneNumber}}
                                        </div>
                                    </div>
                                </div>
                                <div class="table-wrapper">
                                    <div class="table-header">
                                        <div class="th th-first">Item description</div>
                                        <div class="th">Size</div>
                                        <div class="th">Alcohol %</div>
                                        <div class="th">Quantity</div>
                                        <div class="th">Unit Amount</div>
                                        <div class="th">Total Amount</div>
                                    </div>
                                    <div class="table-row" v-for="item in SOInvoiceDetails.wines" :key="item.id">
                                        <div
                                            :class="{'tr tr-first': item.caseSize === 'n/a' || (item.caseSize !== 'n/a' && item.amount !== null), 'tr-first-wine': item.caseSize === 'n/a', 'tr tr-first tr-first-wine-col': item.caseSize !== 'n/a' && item.amount === null}">
                                            {{item.description}}
                                        </div>
                                        <div class="tr">{{item.caseSize}}{{item.caseSize === 'n/a' ? '' : 'l'}}</div>
                                        <div class="tr">{{item.alcoholDegree}}{{item.alcoholDegree === null ? 'n/a' :
                                            '%'}}
                                        </div>
                                        <div class="tr">{{item.quantity}}</div>
                                        <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{(item.amount
                                            / item.quantity).toFixed(2)}}
                                        </div>
                                        <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{item.amount
                                            ? item.amount.toFixed(2) : '-'}}
                                        </div>
                                    </div>
                                </div>
                                <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{SOInvoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row no-margin-bottom no-margin-top">VAT Amount(0%): &euro;0.00
                                </div>
                                <div class="subtotal-row no-margin-top">Total Products Amount: <span>&euro;{{SOInvoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                                </div>
                                <div class="table-wrapper table-wrapper2">
                                    <div class="table-header">
                                        <div class="th th-first">Services Charges</div>
                                        <div class="th">Amount excl. VAT</div>
                                        <div class="th">VAT %</div>
                                        <div class="th">VAT Amount</div>
                                        <div class="th">Amount incl. VAT</div>
                                    </div>
                                    <div class="table-row" v-if="!isCollection">
                                        <div class="tr tr-first">{{ $t('buy13') }}</div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].commissionAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">
                                            {{SOInvoiceDetails.costs[0].commissionVATPercentage.toFixed(2)}}%
                                        </div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}</div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].commissionAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first">Storage (Until
                                            {{formatInvoiceDate(SOInvoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                        </div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].storageAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">{{SOInvoiceDetails.costs[0].storageVATPercentage.toFixed(2)}}%
                                        </div>
                                        <div class="tr">
                                            &euro;{{SOInvoiceDetails.costs[0].storageVATAmount.toFixed(2)}}
                                        </div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].storageAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first">Insurance (Until
                                            {{formatInvoiceDate(SOInvoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                        </div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].insuranceAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">
                                            {{SOInvoiceDetails.costs[0].insuranceVATPercentage.toFixed(2)}}%
                                        </div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].insuranceVATAmount.toFixed(2)}}</div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.costs[0].insuranceAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first tr-first-wine">Total Services Charges</div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.invoice.subtotalCostsAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">&nbsp;</div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.invoice.subtotalCostsAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                </div>

                                <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{(SOInvoiceDetails.invoice.subtotalWines + SOInvoiceDetails.costs[0].commissionAmountExclVAT + SOInvoiceDetails.costs[0].storageAmountExclVAT + SOInvoiceDetails.costs[0].insuranceAmountExclVAT).toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row no-margin-bottom">VAT amount: <span>&euro;{{SOInvoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row2">Total invoice amount: <span>&euro;{{SOInvoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                                </div>

                                <div class="monthly-details" v-if="isCollection">
                                    <div>* Storage amount per case per month € 0.99</div>
                                    <div>** Insurance % on value of wine per month 0.04%</div>
                                    <div>*** Min monthly insurance fee per case € 0.10</div>
                                </div>
                                <div class="monthly-details" v-else>
                                    <div>* Commission 4%</div>
                                    <div>** Storage amount per case per month € 0.99</div>
                                    <div>*** Insurance % on value of wine per month 0.04%</div>
                                    <div>**** Min monthly insurance fee per case € 0.10</div>
                                </div>

                                <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime
                                    suspensif RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au
                                    titre de l`Articel 227 A du CGI
                                </div>
                                <div class="footer">
                                    <div class="footer-left">
                                        <div class="footer-row footer-bold">Vindome Sarl</div>
                                        <div class="footer-row">Villa Mignon, 1 rue Suffren Reymond, 98000, Monaco</div>
                                        <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                    </div>
                                    <div class="footer-right">
                                        <div class="footer-row">www.vindome.net</div>
                                    </div>
                                </div>
                            </v-container>
                            <v-container fluid class="container-invoice" v-else>
                                <div class="header-part"></div>
                                <div class="logo"></div>
                                <div class="header-info">
                                    <div class="header-info-left">
                                        <div class="header-info-row"><span>SALE ORDER</span></div>
                                        <div class="header-info-row"><span>Client ID:</span>
                                            {{SOInvoiceDetails.invoice.userId}}
                                        </div>
                                        <div class="header-info-row"><span>Invoice #:</span>
                                            {{SOInvoiceDetails.invoice.userId}}-SO-{{SOInvoiceDetails.invoice.id}}
                                        </div>
                                        <div class="header-info-row"><span>Sale order Date:</span> {{
                                            formatInvoiceDate(SOInvoiceDetails.invoice.createdOn) }}
                                        </div>
                                        <div class="header-info-row"><span>Reference Number:</span> {{
                                            SOInvoiceDetails.invoice.sogenId || "-" }}
                                        </div>
                                        <div class="header-info-row"><span>Page:</span> 1/1</div>
                                    </div>
                                    <div class="header-info-right">
                                        <div class="header-info-row">{{SOInvoiceDetails.address.clientName}}</div>
                                        <div class="header-info-row">{{SOInvoiceDetails.address.address1}}</div>
                                        <div class="header-info-row" v-if="SOInvoiceDetails.address.address2">
                                            {{SOInvoiceDetails.address.address2}}
                                        </div>
                                        <div class="header-info-row">{{SOInvoiceDetails.address.postCode}},
                                            {{SOInvoiceDetails.address.city}}
                                        </div>
                                        <div class="header-info-row">{{SOInvoiceDetails.address.country}}</div>

                                        <div class="header-info-row vat"><strong>Vat Number:</strong>
                                            {{SOInvoiceDetails.address.vatNumber || '-'}}
                                        </div>
                                        <div class="header-info-row"><strong>Email:</strong>
                                            {{SOInvoiceDetails.address.email}}
                                        </div>
                                        <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                            {{SOInvoiceDetails.address.phoneNumber}}
                                        </div>
                                    </div>
                                </div>
                                <div class="table-wrapper table-wrapper-monthly">
                                    <div class="table-header">
                                        <div class="th th-first th-first-monthly">Item description</div>
                                        <div class="th">Size</div>
                                        <div class="th">Alc.%</div>
                                        <div class="th">Quantity</div>
                                        <div class="th">Amount</div>
                                    </div>
                                    <div class="table-row table-row-details" v-for="item in SOInvoiceDetails.wines"
                                         :key="item.id">
                                        <div class="tr tr-first-monthly">{{item.description}}</div>
                                        <div class="tr">{{ item.caseSize === 'n/a' ? '-' : `${item.caseSize}l` }}</div>
                                        <div class="tr">{{item.alcoholDegree }}</div>
                                        <div class="tr">{{item.quantity }}</div>
                                        <div class="tr">{{item.amount ? formatPrice(item.amount.toLocaleString("fi-FI",
                                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) :
                                            '-'}}
                                        </div>
                                    </div>

                                    <div class="table-row">
                                        <div class="tr tr-first tr-first-monthly">&nbsp;</div>
                                        <div class="tr">&nbsp;</div>
                                        <div class="tr">&nbsp;</div>
                                        <div class="tr">Amount excl. VAT:</div>
                                        <div class="tr">&euro;{{SOInvoiceDetails.invoice.subtotalWines.toFixed(2)}}
                                        </div>
                                    </div>
                                </div>

                                <div class="table-wrapper table-wrapper3">
                                    <div class="table-header">
                                        <div class="th th-first">Services Charges</div>
                                        <div class="th">Amount excl. VAT</div>
                                        <div class="th">VAT %</div>
                                        <div class="th">VAT amount</div>
                                        <div class="th">Amount incl. VAT</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first">{{ $t('buy13') }}</div>
                                        <div class="tr">- &euro;{{costDesc.commissionAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">{{costDesc.commissionVATPercentage}}%</div>
                                        <div class="tr">- &euro;{{costDesc.commissionVATAmount.toFixed(2)}}</div>
                                        <div class="tr">- &euro;{{costDesc.commissionAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                </div>
                                <div class="subtotal-row3">Total Invoice Amount excl. VAT: <span>&euro;{{(SOInvoiceDetails.invoice.subtotalWines + SOInvoiceDetails.invoice.subtotalCostsAmountExclVAT).toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row3">Total Invoice VAT Amount: <span>- &euro;{{SOInvoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}</span>
                                </div>

                                <div class="subtotal-row2">Total invoice amount: <span>&euro;{{SOInvoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                                </div>
                                <div class="monthly-details">
                                    <div>* Commission (4%)</div>
                                </div>
                                <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime
                                    suspensif RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au
                                    titre de l`Articel 227 A du CGI
                                </div>
                                <div class="footer">
                                    <div class="footer-left">
                                        <div class="footer-row footer-bold">Vindome Sarl</div>
                                        <div class="footer-row">Villa Mignon, 1 rue Suffren Reymond, 98000, Monaco</div>
                                        <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                    </div>
                                    <div class="footer-right">
                                        <div class="footer-row">www.vindome.net</div>
                                    </div>
                                </div>
                            </v-container>
                        </v-card>
                        <div class="download-pdf" v-on:click="downloadSOInvoicePDF">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path d="M0 0h24v24H0z" fill="none"/>
                                <path
                                    d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
                            </svg>
                            {{ $t('download') }}
                        </div>
                    </div>
                    <div v-if="showInvoice">
                        <div class="back-invoice" v-on:click="onBackButtonHandler">
                            <div>{{ $t('back') }}</div>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path d="M0 0h24v24H0z" fill="none"/>
                                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                            </svg>
                        </div>
                        <v-card header-tag="header">
                            <v-container fluid class="container-invoice" v-if="invoiceDetails.invoiceType === 1">
                                <div class="header-part"></div>
                                <div class="logo"></div>
                                <div class="header-info">
                                    <div class="header-info-left">
                                        <div class="header-info-row"><span>INVOICE</span></div>
                                        <div class="header-info-row"><span>Client ID:</span>
                                            {{invoiceDetails.invoice.userId}}
                                        </div>
                                        <div class="header-info-row">
                                            <span>Invoice #:</span>
                                            <span style="font-weight: normal" v-if="invoiceDetails.invoice.isGift">
                                                {{invoiceDetails.invoice.userId}}-G-{{invoiceDetails.invoice.id}}
                                            </span>
                                            <span style="font-weight: normal" v-else>
                                                {{invoiceDetails.invoice.userId}}-{{invoiceDetails.invoice.id}}
                                            </span>
                                        </div>
                                        <div class="header-info-row"><span>Invoice Date:</span> {{
                                            formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                        </div>
                                        <div class="header-info-row"><span>Reference Number:</span> {{
                                            invoiceDetails.invoice.sogenId || "-" }}
                                        </div>
                                        <div class="header-info-row"><span>Page:</span> 1/1</div>
                                    </div>
                                    <div class="header-info-right">
                                        <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                        <div class="header-info-row">{{invoiceDetails.address.address1}}</div>
                                        <div class="header-info-row" v-if="invoiceDetails.address.address2">
                                            {{invoiceDetails.address.address2}}
                                        </div>
                                        <div class="header-info-row">{{invoiceDetails.invoice.postCode}},
                                            {{invoiceDetails.invoice.city}}
                                        </div>
                                        <div class="header-info-row">{{invoiceDetails.invoice.countryName}}</div>

                                        <div class="header-info-row vat"><strong>Vat Number:</strong>
                                            {{invoiceDetails.address.vatNumber}}
                                        </div>
                                        <div class="header-info-row"><strong>Email:</strong>
                                            {{invoiceDetails.address.email}}
                                        </div>
                                        <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                            {{invoiceDetails.address.phoneNumber}}
                                        </div>
                                    </div>
                                </div>
                                <div class="table-wrapper">
                                    <div class="table-header">
                                        <div class="th th-first">Item description</div>
                                        <div class="th">Size</div>
                                        <div class="th">Alcohol %</div>
                                        <div class="th">Quantity</div>
                                        <div class="th">Unit Amount</div>
                                        <div class="th">Total Amount</div>
                                    </div>
                                    <div class="table-row" v-for="item in invoiceDetails.wines" :key="item.id">
                                        <div
                                            :class="{'tr tr-first': item.caseSize === 'n/a' || (item.caseSize !== 'n/a' && item.amount !== null), 'tr-first-wine': item.caseSize === 'n/a', 'tr tr-first tr-first-wine-col': item.caseSize !== 'n/a' && item.amount === null}">
                                            {{item.description}}
                                        </div>
                                        <div class="tr">{{item.caseSize}}{{item.caseSize === 'n/a' ? '' : 'l'}}</div>
                                        <div class="tr">{{item.alcoholDegree}}{{item.alcoholDegree === null ? 'n/a' :
                                            '%'}}
                                        </div>
                                        <div class="tr">{{item.quantity}}</div>
                                        <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{(item.amount
                                            / item.quantity).toFixed(2)}}
                                        </div>
                                        <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{item.amount
                                            ? item.amount.toFixed(2) : '-'}}
                                        </div>
                                    </div>
                                </div>
                                <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row no-margin-bottom no-margin-top">VAT Amount(0%): &euro;0.00
                                </div>
                                <div class="subtotal-row no-margin-top">Total Products Amount: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                                </div>
                                <div class="table-wrapper table-wrapper2">
                                    <div class="table-header">
                                        <div class="th th-first">Services Charges</div>
                                        <div class="th">Amount excl. VAT</div>
                                        <div class="th">VAT %</div>
                                        <div class="th">VAT Amount</div>
                                        <div class="th">Amount incl. VAT</div>
                                    </div>
                                    <div class="table-row" v-if="!isCollection">
                                        <div class="tr tr-first">{{ $t('buy13') }}</div>
                                        <div class="tr">&euro;{{invoiceDetails.costs[0].commissionAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">
                                            {{invoiceDetails.costs[0].commissionVATPercentage.toFixed(2)}}%
                                        </div>
                                        <div class="tr">
                                            &euro;{{invoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}
                                        </div>
                                        <div class="tr">&euro;{{invoiceDetails.costs[0].commissionAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first">Storage (Until
                                            {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                        </div>
                                        <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">{{invoiceDetails.costs[0].storageVATPercentage.toFixed(2)}}%
                                        </div>
                                        <div class="tr">&euro;{{invoiceDetails.costs[0].storageVATAmount.toFixed(2)}}
                                        </div>
                                        <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first">Insurance (Until
                                            {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                        </div>
                                        <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">{{invoiceDetails.costs[0].insuranceVATPercentage.toFixed(2)}}%
                                        </div>
                                        <div class="tr">
                                            &euro;{{invoiceDetails.costs[0].insuranceVATAmount.toFixed(2)}}
                                        </div>
                                        <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first tr-first-wine">Total Services Charges</div>
                                        <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">&nbsp;</div>
                                        <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</div>
                                        <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                </div>

                                <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.subtotalWines + invoiceDetails.costs[0].commissionAmountExclVAT + invoiceDetails.costs[0].storageAmountExclVAT + invoiceDetails.costs[0].insuranceAmountExclVAT).toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row no-margin-bottom">VAT amount: <span>&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row no-margin-bottom" v-if="invoiceDetails.invoice.promoCodeBonus">
                                    Gift Voucher:
                                    <span>&euro;{{invoiceDetails.invoice.promoCodeBonus.toFixed(2)}}</span></div>
                                <div class="subtotal-row2">Total invoice amount: <span>&euro;{{invoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                                </div>

                                <div class="monthly-details" v-if="isCollection">
                                    <div>* Storage amount per case per month € 0.99</div>
                                    <div>** Insurance % on value of wine per month 0.04%</div>
                                    <div>*** Min monthly insurance fee per case € 0.10</div>
                                </div>
                                <div class="monthly-details" v-else>
                                    <div>* Commission 4%</div>
                                    <div>** Storage amount per case per month € 0.99</div>
                                    <div>*** Insurance % on value of wine per month 0.04%</div>
                                    <div>**** Min monthly insurance fee per case € 0.10</div>
                                </div>

                                <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime
                                    suspensif RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au
                                    titre de l`Articel 227 A du CGI
                                </div>
                                <div class="footer">
                                    <div class="footer-left">
                                        <div class="footer-row footer-bold">Vindome Sarl</div>
                                        <div class="footer-row">{{invoiceDetails.invoice.companyAddress}}</div>
                                        <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                    </div>
                                    <div class="footer-right">
                                        <div class="footer-row">www.vindome.net</div>
                                    </div>
                                </div>
                            </v-container>
                            <v-container fluid class="container-invoice" v-else>
                                <div class="header-part"></div>
                                <div class="logo"></div>
                                <div class="header-info">
                                    <div class="header-info-left">
                                        <div class="header-info-row"><span>MONTHLY INVOICE</span></div>
                                        <div class="header-info-row"><span>Client ID:</span>
                                            {{invoiceDetails.invoice.userId}}
                                        </div>
                                        <div class="header-info-row"><span>Invoice #:</span>
                                            {{invoiceDetails.invoice.userId}}-SI-{{invoiceDetails.invoice.id}}
                                        </div>
                                        <div class="header-info-row"><span>Invoice date:</span> {{
                                            formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                        </div>
                                        <div class="header-info-row"><span>Invoice period:</span> {{
                                            formatInvoiceDate(invoiceDetails.invoice.createdOn, true) }}
                                        </div>
                                        <div class="header-info-row"><span>Page:</span> 1/1</div>
                                    </div>
                                    <div class="header-info-right">
                                        <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                        <div class="header-info-row">{{invoiceDetails.address.street}}</div>
                                        <div class="header-info-row" v-if="invoiceDetails.address.street1">
                                            {{invoiceDetails.address.street1}}
                                        </div>
                                        <div class="header-info-row">{{invoiceDetails.address.postCode}},
                                            {{invoiceDetails.address.city}}
                                        </div>
                                        <div class="header-info-row">{{invoiceDetails.address.country}}</div>

                                        <div class="header-info-row vat"><strong>Vat Number:</strong>
                                            {{invoiceDetails.address.vatNumber || '-'}}
                                        </div>
                                        <div class="header-info-row"><strong>Email:</strong> {{invoiceDetails.email}}
                                        </div>
                                        <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                            {{invoiceDetails.address.phoneNumber}}
                                        </div>
                                    </div>
                                </div>
                                <div class="table-wrapper table-wrapper-monthly">
                                    <div class="table-header">
                                        <div class="th th-first th-first-monthly">Item description</div>
                                        <div class="th">{{ $t('cases') }}</div>
                                        <div class="th">Days in storage</div>
                                        <div class="th">Total case/days</div>
                                        <div class="th">Market value</div>
                                        <div class="th">Insurance value</div>
                                        <div class="th">{{ $t('buy14') }}</div>
                                        <div class="th">{{ $t('buy15') }}</div>
                                    </div>
                                    <div class="table-row table-row-details" v-for="item in invoiceDetails.details"
                                         :key="item.id">
                                        <div class="table-row-desc">{{item.description}}</div>
                                        <div class="tr tr-first tr-first-monthly">from {{
                                            formatInvoiceDate(item.startPeriod)}} to {{
                                            formatInvoiceDate(item.endPeriod)}}
                                        </div>
                                        <div class="tr">{{item.cases}}</div>
                                        <div class="tr">{{item.daysInStorage}}</div>
                                        <div class="tr">{{item.totalCaseDays}}</div>
                                        <div class="tr">&euro;{{item.marketValue ? item.marketValue : '-'}}</div>
                                        <div class="tr">&euro;{{item.insuranceValue.toFixed(2)}}</div>
                                        <div class="tr">&euro;{{item.storageFee.toFixed(2)}}</div>
                                        <div class="tr">&euro;{{item.insuranceFee.toFixed(2)}}</div>
                                    </div>
                                </div>

                                <div class="table-wrapper table-wrapper3">
                                    <div class="table-header">
                                        <div class="th th-first">Services Charges</div>
                                        <div class="th">Amount excl. VAT</div>
                                        <div class="th">VAT %</div>
                                        <div class="th">VAT amount</div>
                                        <div class="th">Amount incl. VAT</div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first">Monthly storage</div>
                                        <div class="tr">
                                            &euro;{{invoiceDetails.invoice.storageAmountExclVAT.toFixed(2)}}
                                        </div>
                                        <div class="tr">{{invoiceDetails.invoice.storageVATPercentage * 100}}%</div>
                                        <div class="tr">&euro;{{invoiceDetails.invoice.storageVATAmount.toFixed(2)}}
                                        </div>
                                        <div class="tr">
                                            &euro;{{invoiceDetails.invoice.storageAmountInclVAT.toFixed(2)}}
                                        </div>
                                    </div>
                                    <div class="table-row">
                                        <div class="tr tr-first">Monthly insurance</div>
                                        <div class="tr">&euro;{{invoiceDetails.invoice.insuranceAmountExclVAT.toFixed(2)}}</div>
                                        <div class="tr">{{invoiceDetails.invoice.insuranceVATPercentage * 100}}%</div>
                                        <div class="tr">&euro;{{invoiceDetails.invoice.insuranceVATAmount.toFixed(2)}}
                                        </div>
                                        <div class="tr">&euro;{{invoiceDetails.invoice.insuranceAmountInclVAT.toFixed(2)}}</div>
                                    </div>
                                </div>
                                <div class="subtotal-row3">Total Invoice Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.storageAmountExclVAT + invoiceDetails.invoice.insuranceAmountExclVAT).toFixed(2)}}</span>
                                </div>
                                <div class="subtotal-row3">Total Invoice VAT Amount: <span>&euro;{{(invoiceDetails.invoice.storageVATAmount + invoiceDetails.invoice.insuranceVATAmount).toFixed(2)}}</span>
                                </div>

                                <div class="subtotal-row2">Total invoice amount: <span>&euro;{{invoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                                </div>
                                <div class="monthly-details">
                                    <div>* Payment has to be settled within 15 days of the receipt of the invoice</div>
                                    <div>** Storage amount per case per month € 0.99</div>
                                    <div>*** Insurance % on value of wine per month 0.04%</div>
                                </div>
                                <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime
                                    suspensif RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au
                                    titre de l`Articel 227 A du CGI
                                </div>
                                <div class="footer">
                                    <div class="footer-left">
                                        <div class="footer-row footer-bold">Vindome Sarl</div>
                                        <div class="footer-row">{{invoiceDetails.invoice.companyAddress}}</div>
                                        <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                    </div>
                                    <div class="footer-right">
                                        <div class="footer-row">www.vindome.net</div>
                                    </div>
                                </div>
                            </v-container>
                        </v-card>
                        <div class="download-pdf" v-on:click="downloadInvoicePDF">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path d="M0 0h24v24H0z" fill="none"/>
                                <path
                                    d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
                            </svg>
                            {{ $t('download') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="trades-history-wrapper" v-else>
        <div class="no-data" v-if="!tradesListLength">{{ $t('trade-history0') }}</div>
        <div v-else>
            <v-data-table v-if="!showInvoice && !showSOInvoice" :headers="headers" :items="filteredItems"
                          :items-per-page="50" hide-default-footer fixed-header class="default-table custom-table">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>
                            {{ item.date }}
                        </td>
                        <td>
                            {{item.type}}
                        </td>
                        <td class="wineinfo-td">
                            <div class="wine-name">{{ item.wine }}</div>
                        </td>
                        <td class="text-right">
                            {{item.quantity}}
                        </td>
                        <td class="text-right">
                            {{item.service}}
                        </td>
                        <td class="text-right">
                            {{item.total}}
                        </td>
                        <td class="text-right" v-on:click="() => { goToInvoiceDetails(item) }">
                            <div class="hyperlink-td">
                                {{item.documentId}}
                                <div class="link-border"></div>
                            </div>
                        </td>
                        <td class="text-right">
                            {{item.status}}
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <div class="invoice-details-wrapper" v-else>
                <div v-if="showSOInvoice">
                    <div class="back-invoice" v-on:click="onBackButtonHandler">
                        <div>{{ $t('back') }}</div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                        </svg>
                    </div>
                    <v-card header-tag="header">
                        <v-container fluid class="container-invoice sale-order-container"
                                     v-if="SOInvoiceDetails.invoiceType === 1">
                            <div class="header-part"></div>
                            <div class="logo"></div>
                            <div class="header-info">
                                <div class="header-info-left">
                                    <div class="header-info-row"><span>SALE ORDER</span></div>
                                    <div class="header-info-row"><span>Client ID:</span>
                                        {{SOSOInvoiceDetails.invoice.userId}}
                                    </div>
                                    <div class="header-info-row"><span>Invoice #:</span>
                                        {{SOInvoiceDetails.invoice.userId}}-SO-{{SOInvoiceDetails.invoice.id}}
                                    </div>
                                    <div class="header-info-row"><span>Invoice date:</span> {{
                                        formatInvoiceDate(SOInvoiceDetails.invoice.createdOn) }}
                                    </div>
                                    <div class="header-info-row"><span>Invoice period:</span> {{
                                        formatInvoiceDate(SOInvoiceDetails.invoice.createdOn, true) }}
                                    </div>
                                    <div class="header-info-row"><span>Page:</span> 1/1</div>
                                </div>
                                <div class="header-info-right">
                                    <div class="header-info-row">{{SOInvoiceDetails.address.clientName}}</div>
                                    <div class="header-info-row">{{SOInvoiceDetails.address.address1}}</div>
                                    <div class="header-info-row" v-if="SOInvoiceDetails.address.address2">
                                        {{SOInvoiceDetails.address.address2}}
                                    </div>
                                    <div class="header-info-row">{{SOInvoiceDetails.address.postCode}},
                                        {{SOInvoiceDetails.address.city}}
                                    </div>
                                    <div class="header-info-row">{{SOInvoiceDetails.address.country}}</div>

                                    <div class="header-info-row vat"><strong>Vat Number:</strong>
                                        {{SOInvoiceDetails.address.vatNumber}}
                                    </div>
                                    <div class="header-info-row"><strong>Email:</strong> {{
                                        SOInvoiceDetails.address.email }}
                                    </div>
                                    <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                        {{SOInvoiceDetails.address.phoneNumber}}
                                    </div>
                                </div>
                            </div>
                            <div class="table-wrapper">
                                <div class="table-header">
                                    <div class="th th-first">Item description</div>
                                    <div class="th">Size</div>
                                    <div class="th">Alcohol %</div>
                                    <div class="th">Quantity</div>
                                    <div class="th">Unit Amount</div>
                                    <div class="th">Total Amount</div>
                                </div>
                                <div class="table-row" v-for="item in SOInvoiceDetails.wines" :key="item.id">
                                    <div
                                        :class="{'tr tr-first': item.caseSize === 'n/a' || (item.caseSize !== 'n/a' && item.amount !== null), 'tr-first-wine': item.caseSize === 'n/a', 'tr tr-first tr-first-wine-col': item.caseSize !== 'n/a' && item.amount === null}">
                                        {{item.description}}
                                    </div>
                                    <div class="tr">{{item.caseSize}}{{item.caseSize === 'n/a' ? '' : 'l'}}</div>
                                    <div class="tr">{{item.alcoholDegree}}{{item.alcoholDegree === null ? 'n/a' :
                                        '%'}}
                                    </div>
                                    <div class="tr">{{item.quantity}}</div>
                                    <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{(item.amount
                                        / item.quantity).toFixed(2)}}
                                    </div>
                                    <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{item.amount
                                        ? item.amount.toFixed(2) : '-'}}
                                    </div>
                                </div>
                            </div>
                            <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{SOInvoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row no-margin-bottom no-margin-top">VAT Amount(0%): &euro;0.00</div>
                            <div class="subtotal-row no-margin-top">Total Products Amount: <span>&euro;{{SOInvoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                            </div>
                            <div class="table-wrapper table-wrapper2">
                                <div class="table-header">
                                    <div class="th th-first">Services Charges</div>
                                    <div class="th">Amount excl. VAT</div>
                                    <div class="th">VAT %</div>
                                    <div class="th">VAT Amount</div>
                                    <div class="th">Amount incl. VAT</div>
                                </div>
                                <div class="table-row" v-if="!isCollection">
                                    <div class="tr tr-first">{{ $t('buy13') }}</div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.costs[0].commissionAmountExclVAT.toFixed(2)}}</div>
                                    <div class="tr">{{SOInvoiceDetails.costs[0].commissionVATPercentage.toFixed(2)}}%
                                    </div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}
                                    </div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.costs[0].commissionAmountInclVAT.toFixed(2)}}</div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first">Storage (Until
                                        {{formatInvoiceDate(SOInvoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                    </div>
                                    <div class="tr">
                                        &euro;{{SOInvoiceDetails.costs[0].storageAmountExclVAT.toFixed(2)}}
                                    </div>
                                    <div class="tr">{{SOInvoiceDetails.costs[0].storageVATPercentage.toFixed(2)}}%</div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.costs[0].storageVATAmount.toFixed(2)}}
                                    </div>
                                    <div class="tr">
                                        &euro;{{SOInvoiceDetails.costs[0].storageAmountInclVAT.toFixed(2)}}
                                    </div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first">Insurance (Until
                                        {{formatInvoiceDate(SOInvoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                    </div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.costs[0].insuranceAmountExclVAT.toFixed(2)}}</div>
                                    <div class="tr">{{SOInvoiceDetails.costs[0].insuranceVATPercentage.toFixed(2)}}%
                                    </div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.costs[0].insuranceVATAmount.toFixed(2)}}
                                    </div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.costs[0].insuranceAmountInclVAT.toFixed(2)}}</div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first tr-first-wine">Total Services Charges</div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.invoice.subtotalCostsAmountExclVAT.toFixed(2)}}</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">
                                        &euro;{{SOInvoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}
                                    </div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.invoice.subtotalCostsAmountInclVAT.toFixed(2)}}</div>
                                </div>
                            </div>

                            <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{(SOInvoiceDetails.invoice.subtotalWines + SOInvoiceDetails.costs[0].commissionAmountExclVAT + SOInvoiceDetails.costs[0].storageAmountExclVAT + SOInvoiceDetails.costs[0].insuranceAmountExclVAT).toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row no-margin-bottom">VAT amount: <span>&euro;{{SOInvoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row2">Total invoice amount: <span>&euro;{{SOInvoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                            </div>

                            <div class="monthly-details" v-if="isCollection">
                                <div>* Storage amount per case per month € 0.99</div>
                                <div>** Insurance % on value of wine per month 0.04%</div>
                                <div>*** Min monthly insurance fee per case € 0.10</div>
                            </div>
                            <div class="monthly-details" v-else>
                                <div>* Commission 4%</div>
                                <div>** Storage amount per case per month € 0.99</div>
                                <div>*** Insurance % on value of wine per month 0.04%</div>
                                <div>**** Min monthly insurance fee per case € 0.10</div>
                            </div>

                            <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif
                                RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de
                                l`Articel 227 A du CGI
                            </div>
                            <div class="footer">
                                <div class="footer-left">
                                    <div class="footer-row footer-bold">Vindome Sarl</div>
                                    <div class="footer-row">Villa Mignon, 1 rue Suffren Reymond, 98000, Monaco</div>
                                    <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-row">www.vindome.net</div>
                                </div>
                            </div>
                        </v-container>
                        <v-container fluid class="container-invoice sale-order-container" v-else>
                            <div class="header-part"></div>
                            <div class="logo"></div>
                            <div class="header-info">
                                <div class="header-info-left">
                                    <div class="header-info-row"><span>SALE ORDER</span></div>
                                    <div class="header-info-row"><span>Client ID:</span>
                                        {{SOInvoiceDetails.invoice.userId}}
                                    </div>
                                    <div class="header-info-row"><span>Invoice #:</span>
                                        {{SOInvoiceDetails.invoice.userId}}-SO-{{SOInvoiceDetails.invoice.id}}
                                    </div>
                                    <div class="header-info-row"><span>Sale order Date:</span> {{
                                        formatInvoiceDate(SOInvoiceDetails.invoice.createdOn) }}
                                    </div>
                                    <div class="header-info-row"><span>Reference Number:</span> {{
                                        SOInvoiceDetails.invoice.sogenId || "-" }}
                                    </div>
                                    <div class="header-info-row"><span>Page:</span> 1/1</div>
                                </div>
                                <div class="header-info-right">
                                    <div class="header-info-row">{{SOInvoiceDetails.address.clientName}}</div>
                                    <div class="header-info-row">{{SOInvoiceDetails.address.address1}}</div>
                                    <div class="header-info-row" v-if="SOInvoiceDetails.address.address2">
                                        {{SOInvoiceDetails.address.address2}}
                                    </div>
                                    <div class="header-info-row">{{SOInvoiceDetails.address.postCode}},
                                        {{SOInvoiceDetails.address.city}}
                                    </div>
                                    <div class="header-info-row">{{SOInvoiceDetails.address.country}}</div>

                                    <div class="header-info-row vat"><strong>Vat Number:</strong>
                                        {{SOInvoiceDetails.address.vatNumber || '-'}}
                                    </div>
                                    <div class="header-info-row"><strong>Email:</strong>
                                        {{SOInvoiceDetails.address.email}}
                                    </div>
                                    <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                        {{SOInvoiceDetails.address.phoneNumber}}
                                    </div>
                                </div>
                            </div>
                            <div class="table-wrapper table-wrapper-monthly">
                                <div class="table-header">
                                    <div class="th th-first th-first-monthly">Item description</div>
                                    <div class="th">Size</div>
                                    <div class="th">Alc.%</div>
                                    <div class="th">Quantity</div>
                                    <div class="th">Amount</div>
                                </div>
                                <div class="table-row table-row-details" v-for="item in SOInvoiceDetails.wines"
                                     :key="item.id">
                                    <div class="tr tr-first-monthly">{{item.description}}</div>
                                    <div class="tr">{{ item.caseSize === 'n/a' ? '-' : `${item.caseSize}l` }}</div>
                                    <div class="tr">{{item.alcoholDegree }}</div>
                                    <div class="tr">{{item.quantity }}</div>
                                    <div class="tr">{{item.amount ? formatPrice(item.amount.toLocaleString("fi-FI", {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) : '-'}}
                                    </div>
                                </div>

                                <div class="table-row">
                                    <div class="tr tr-first tr-first-monthly">&nbsp;</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">Amount excl. VAT:</div>
                                    <div class="tr">&euro;{{SOInvoiceDetails.invoice.subtotalWines.toFixed(2)}}</div>
                                </div>
                            </div>

                            <div class="table-wrapper table-wrapper3">
                                <div class="table-header">
                                    <div class="th th-first">Services Charges</div>
                                    <div class="th">Amount excl. VAT</div>
                                    <div class="th">VAT %</div>
                                    <div class="th">VAT amount</div>
                                    <div class="th">Amount incl. VAT</div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first">{{ $t('buy13') }}</div>
                                    <div class="tr">- &euro;{{costDesc.commissionAmountExclVAT.toFixed(2)}}</div>
                                    <div class="tr">{{costDesc.commissionVATPercentage}}%</div>
                                    <div class="tr">- &euro;{{costDesc.commissionVATAmount.toFixed(2)}}</div>
                                    <div class="tr">- &euro;{{costDesc.commissionAmountInclVAT.toFixed(2)}}</div>
                                </div>
                            </div>
                            <div class="subtotal-row3">Total Invoice Amount excl. VAT: <span>&euro;{{(SOInvoiceDetails.invoice.subtotalWines + SOInvoiceDetails.invoice.subtotalCostsAmountExclVAT).toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row3">Total Invoice VAT Amount: <span>- &euro;{{SOInvoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}</span>
                            </div>

                            <div class="subtotal-row2">Total invoice amount: <span>&euro;{{SOInvoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                            </div>
                            <div class="monthly-details">
                                <div>* Commission (4%)</div>
                            </div>
                            <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif
                                RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de
                                l`Articel 227 A du CGI
                            </div>
                            <div class="footer">
                                <div class="footer-left">
                                    <div class="footer-row footer-bold">Vindome Sarl</div>
                                    <div class="footer-row">Villa Mignon, 1 rue Suffren Reymond, 98000, Monaco</div>
                                    <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-row">www.vindome.net</div>
                                </div>
                            </div>
                        </v-container>
                    </v-card>
                    <div class="download-pdf" v-on:click="downloadSOInvoicePDF">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
                        </svg>
                        {{ $t('download') }}
                    </div>
                </div>
                <div v-if="showInvoice">
                    <div class="back-invoice" v-on:click="onBackButtonHandler">
                        <div>{{ $t('back') }}</div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                        </svg>
                    </div>
                    <v-card header-tag="header">
                        <v-container fluid class="container-invoice" v-if="invoiceDetails.invoiceType === 1">
                            <div class="header-part"></div>
                            <div class="logo"></div>
                            <div class="header-info">
                                <div class="header-info-left">
                                    <div class="header-info-row"><span>INVOICE</span></div>
                                    <div class="header-info-row"><span>Client ID:</span>
                                        {{invoiceDetails.invoice.userId}}
                                    </div>
                                    <div class="header-info-row">
                                        <span>Invoice #:</span>
                                        <span v-if="invoiceDetails.invoice.isGift" style="font-weight: normal">
                                        {{invoiceDetails.invoice.userId}}-G-{{invoiceDetails.invoice.id}}
                                    </span>
                                        <span style="font-weight: normal" v-else>
                                        {{invoiceDetails.invoice.userId}}-{{invoiceDetails.invoice.id}}
                                    </span>
                                    </div>
                                    <div class="header-info-row"><span>Invoice Date:</span> {{
                                        formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                    </div>
                                    <div class="header-info-row"><span>Reference Number:</span> {{
                                        invoiceDetails.invoice.sogenId || "-" }}
                                    </div>
                                    <div class="header-info-row"><span>Page:</span> 1/1</div>
                                </div>
                                <div class="header-info-right">
                                    <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                    <div class="header-info-row">{{invoiceDetails.address.address1}}</div>
                                    <div class="header-info-row" v-if="invoiceDetails.address.address2">
                                        {{invoiceDetails.address.address2}}
                                    </div>
                                    <div class="header-info-row">{{invoiceDetails.invoice.postCode}},
                                        {{invoiceDetails.invoice.city}}
                                    </div>
                                    <div class="header-info-row">{{invoiceDetails.invoice.countryName}}</div>

                                    <div class="header-info-row vat"><strong>Vat Number:</strong>
                                        {{invoiceDetails.address.vatNumber}}
                                    </div>
                                    <div class="header-info-row"><strong>Email:</strong>
                                        {{invoiceDetails.address.email}}
                                    </div>
                                    <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                        {{invoiceDetails.address.phoneNumber}}
                                    </div>
                                </div>
                            </div>
                            <div class="table-wrapper">
                                <div class="table-header">
                                    <div class="th th-first">Item description</div>
                                    <div class="th">Size</div>
                                    <div class="th">Alcohol %</div>
                                    <div class="th">Quantity</div>
                                    <div class="th">Unit Amount</div>
                                    <div class="th">Total Amount</div>
                                </div>
                                <div class="table-row" v-for="item in invoiceDetails.wines" :key="item.id">
                                    <div
                                        :class="{'tr tr-first': item.caseSize === 'n/a' || (item.caseSize !== 'n/a' && item.amount !== null), 'tr-first-wine': item.caseSize === 'n/a', 'tr tr-first tr-first-wine-col': item.caseSize !== 'n/a' && item.amount === null}">
                                        {{item.description}}
                                    </div>
                                    <div class="tr">{{item.caseSize}}{{item.caseSize === 'n/a' ? '' : 'l'}}</div>
                                    <div class="tr">{{item.alcoholDegree}}{{item.alcoholDegree === null ? 'n/a' :
                                        '%'}}
                                    </div>
                                    <div class="tr">{{item.quantity}}</div>
                                    <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{(item.amount
                                        / item.quantity).toFixed(2)}}
                                    </div>
                                    <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{item.amount
                                        ? item.amount.toFixed(2) : '-'}}
                                    </div>
                                </div>
                            </div>
                            <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row no-margin-bottom no-margin-top">VAT Amount(0%): &euro;0.00</div>
                            <div class="subtotal-row no-margin-top">Total Products Amount: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                            </div>
                            <div class="table-wrapper table-wrapper2">
                                <div class="table-header">
                                    <div class="th th-first">Services Charges</div>
                                    <div class="th">Amount excl. VAT</div>
                                    <div class="th">VAT %</div>
                                    <div class="th">VAT Amount</div>
                                    <div class="th">Amount incl. VAT</div>
                                </div>
                                <div class="table-row" v-if="!isCollection">
                                    <div class="tr tr-first">{{ $t('buy13') }}</div>
                                    <div class="tr">
                                        &euro;{{invoiceDetails.costs[0].commissionAmountExclVAT.toFixed(2)}}
                                    </div>
                                    <div class="tr">{{invoiceDetails.costs[0].commissionVATPercentage.toFixed(2)}}%
                                    </div>
                                    <div class="tr">&euro;{{invoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}
                                    </div>
                                    <div class="tr">
                                        &euro;{{invoiceDetails.costs[0].commissionAmountInclVAT.toFixed(2)}}
                                    </div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first">Storage (Until
                                        {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                    </div>
                                    <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountExclVAT.toFixed(2)}}
                                    </div>
                                    <div class="tr">{{invoiceDetails.costs[0].storageVATPercentage.toFixed(2)}}%</div>
                                    <div class="tr">&euro;{{invoiceDetails.costs[0].storageVATAmount.toFixed(2)}}</div>
                                    <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountInclVAT.toFixed(2)}}
                                    </div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first">Insurance (Until
                                        {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                    </div>
                                    <div class="tr">
                                        &euro;{{invoiceDetails.costs[0].insuranceAmountExclVAT.toFixed(2)}}
                                    </div>
                                    <div class="tr">{{invoiceDetails.costs[0].insuranceVATPercentage.toFixed(2)}}%</div>
                                    <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceVATAmount.toFixed(2)}}
                                    </div>
                                    <div class="tr">
                                        &euro;{{invoiceDetails.costs[0].insuranceAmountInclVAT.toFixed(2)}}
                                    </div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first tr-first-wine">Total Services Charges</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountExclVAT.toFixed(2)}}</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}
                                    </div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountInclVAT.toFixed(2)}}</div>
                                </div>
                            </div>

                            <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.subtotalWines + invoiceDetails.costs[0].commissionAmountExclVAT + invoiceDetails.costs[0].storageAmountExclVAT + invoiceDetails.costs[0].insuranceAmountExclVAT).toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row no-margin-bottom">VAT amount: <span>&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row no-margin-bottom" v-if="invoiceDetails.invoice.promoCodeBonus">Gift
                                Voucher: <span>&euro;{{invoiceDetails.invoice.promoCodeBonus.toFixed(2)}}</span></div>
                            <div class="subtotal-row2">Total invoice amount: <span>&euro;{{invoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                            </div>

                            <div class="monthly-details" v-if="isCollection">
                                <div>* Storage amount per case per month € 0.99</div>
                                <div>** Insurance % on value of wine per month 0.04%</div>
                                <div>*** Min monthly insurance fee per case € 0.10</div>
                            </div>
                            <div class="monthly-details" v-else>
                                <div>* Commission 4%</div>
                                <div>** Storage amount per case per month € 0.99</div>
                                <div>*** Insurance % on value of wine per month 0.04%</div>
                                <div>**** Min monthly insurance fee per case € 0.10</div>
                            </div>

                            <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif
                                RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de
                                l`Articel 227 A du CGI
                            </div>
                            <div class="footer">
                                <div class="footer-left">
                                    <div class="footer-row footer-bold">Vindome Sarl</div>
                                    <div class="footer-row">{{invoiceDetails.invoice.companyAddress}}</div>
                                    <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-row">www.vindome.net</div>
                                </div>
                            </div>
                        </v-container>
                        <v-container fluid class="container-invoice" v-else>
                            <div class="header-part"></div>
                            <div class="logo"></div>
                            <div class="header-info">
                                <div class="header-info-left">
                                    <div class="header-info-row"><span>MONTHLY INVOICE</span></div>
                                    <div class="header-info-row"><span>Client ID:</span>
                                        {{invoiceDetails.invoice.userId}}
                                    </div>
                                    <div class="header-info-row"><span>Invoice #:</span>
                                        {{invoiceDetails.invoice.userId}}-SI-{{invoiceDetails.invoice.id}}
                                    </div>
                                    <div class="header-info-row"><span>Invoice date:</span> {{
                                        formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                    </div>
                                    <div class="header-info-row"><span>Invoice period:</span> {{
                                        formatInvoiceDate(invoiceDetails.invoice.createdOn, true) }}
                                    </div>
                                    <div class="header-info-row"><span>Page:</span> 1/1</div>
                                </div>
                                <div class="header-info-right">
                                    <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                    <div class="header-info-row">{{invoiceDetails.address.street}}</div>
                                    <div class="header-info-row" v-if="invoiceDetails.address.street1">
                                        {{invoiceDetails.address.street1}}
                                    </div>
                                    <div class="header-info-row">{{invoiceDetails.address.postCode}},
                                        {{invoiceDetails.address.city}}
                                    </div>
                                    <div class="header-info-row">{{invoiceDetails.address.country}}</div>

                                    <div class="header-info-row vat"><strong>Vat Number:</strong>
                                        {{invoiceDetails.address.vatNumber || '-'}}
                                    </div>
                                    <div class="header-info-row"><strong>Email:</strong> {{invoiceDetails.email}}</div>
                                    <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                        {{invoiceDetails.address.phoneNumber}}
                                    </div>
                                </div>
                            </div>
                            <div class="table-wrapper table-wrapper-monthly">
                                <div class="table-header">
                                    <div class="th th-first th-first-monthly">Item description</div>
                                    <div class="th">{{ $t('cases') }}</div>
                                    <div class="th">Days in storage</div>
                                    <div class="th">Total case/days</div>
                                    <div class="th">Market value</div>
                                    <div class="th">Insurance value</div>
                                    <div class="th">{{ $t('buy14') }}</div>
                                    <div class="th">{{ $t('buy15') }}</div>
                                </div>
                                <div class="table-row table-row-details" v-for="item in invoiceDetails.details"
                                     :key="item.id">
                                    <div class="table-row-desc">{{item.description}}</div>
                                    <div class="tr tr-first tr-first-monthly">from {{
                                        formatInvoiceDate(item.startPeriod)}} to {{ formatInvoiceDate(item.endPeriod)}}
                                    </div>
                                    <div class="tr">{{item.cases}}</div>
                                    <div class="tr">{{item.daysInStorage}}</div>
                                    <div class="tr">{{item.totalCaseDays}}</div>
                                    <div class="tr">&euro;{{item.marketValue ? item.marketValue : '-'}}</div>
                                    <div class="tr">&euro;{{item.insuranceValue.toFixed(2)}}</div>
                                    <div class="tr">&euro;{{item.storageFee.toFixed(2)}}</div>
                                    <div class="tr">&euro;{{item.insuranceFee.toFixed(2)}}</div>
                                </div>

                                <div class="table-row">
                                    <div class="tr tr-first tr-first-monthly">&nbsp;</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">&nbsp;</div>
                                    <div class="tr">Amount excl. VAT:</div>
                                    <div class="tr">&euro;{{subtotalStorageMonthly}}</div>
                                    <div class="tr">&euro;{{subtotalInsuranceMonthly}}</div>
                                </div>
                            </div>

                            <div class="table-wrapper table-wrapper3">
                                <div class="table-header">
                                    <div class="th th-first">Services Charges</div>
                                    <div class="th">Amount excl. VAT</div>
                                    <div class="th">VAT %</div>
                                    <div class="th">VAT amount</div>
                                    <div class="th">Amount incl. VAT</div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first">Monthly storage</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.storageAmountExclVAT.toFixed(2)}}
                                    </div>
                                    <div class="tr">{{invoiceDetails.invoice.storageVATPercentage * 100}}%</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.storageVATAmount.toFixed(2)}}</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.storageAmountInclVAT.toFixed(2)}}
                                    </div>
                                </div>
                                <div class="table-row">
                                    <div class="tr tr-first">Monthly insurance</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.insuranceAmountExclVAT.toFixed(2)}}
                                    </div>
                                    <div class="tr">{{invoiceDetails.invoice.insuranceVATPercentage * 100}}%</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.insuranceVATAmount.toFixed(2)}}</div>
                                    <div class="tr">&euro;{{invoiceDetails.invoice.insuranceAmountInclVAT.toFixed(2)}}
                                    </div>
                                </div>
                            </div>
                            <div class="subtotal-row3">Total Invoice Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.storageAmountExclVAT + invoiceDetails.invoice.insuranceAmountExclVAT).toFixed(2)}}</span>
                            </div>
                            <div class="subtotal-row3">Total Invoice VAT Amount: <span>&euro;{{(invoiceDetails.invoice.storageVATAmount + invoiceDetails.invoice.insuranceVATAmount).toFixed(2)}}</span>
                            </div>

                            <div class="subtotal-row2">Total invoice amount: <span>&euro;{{invoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                            </div>
                            <div class="monthly-details">
                                <div>* Payment has to be settled within 15 days of the receipt of the invoice</div>
                                <div>** Storage amount per case per month € 0.99</div>
                                <div>*** Insurance % on value of wine per month 0.04%</div>
                            </div>
                            <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif
                                RFS n FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de
                                l`Articel 227 A du CGI
                            </div>
                            <div class="footer">
                                <div class="footer-left">
                                    <div class="footer-row footer-bold">Vindome Sarl</div>
                                    <div class="footer-row">{{invoiceDetails.invoice.companyAddress}}</div>
                                    <div class="footer-row">RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00</div>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-row">www.vindome.net</div>
                                </div>
                            </div>
                        </v-container>
                    </v-card>
                    <div class="download-pdf" v-on:click="downloadInvoicePDF">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
                        </svg>
                        {{ $t('download') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {AOrders, AUser} from '@/store/actions';
    import {GCommon, GOrders, GUser} from '@/store/getters';
    import moment from 'moment'

    export default {
        name: "TradesHistory",
        data() {
            return {
                orderMatchId: null,
                showInvoice: false,
                showSOInvoice: false
            };
        },
        computed: {
            ...mapGetters({
                tradesList: GOrders.GET_TRADES_HISTORY,
                invoiceDetails: GUser.GET_INVOICE_DETAILS,
                SOInvoiceDetails: GOrders.GET_SALE_ORDER_DETAILS,
                mobileCheck: GCommon.GET_MOBILE_VERSION
            }),
            headers() {
                return [
                    {text: this.$i18n.t('trade-history1'), value: 'date', class: 'invoiceNumber-th'},
                    {text: this.$i18n.t('trade-history3'), value: 'type'},
                    {text: this.$i18n.t('wine'), value: 'wine'},
                    {text: this.$i18n.t('quantity'), align: 'right', value: 'quantity'},
                    {text: this.$i18n.t('trade-history4'), align: 'right', value: 'service'},
                    {text: this.$i18n.t('trade-history5'), align: 'right', value: 'total'},
                    {text: this.$i18n.t('doc-num'), align: 'right', value: 'documentId'},
                    {text: this.$i18n.t('invoice06'), align: 'right', value: 'status'}
                ]
            },
            isCollection() {
                let isCollection = false;
                if (this.invoiceDetails.invoiceType === 1) {
                    this.invoiceDetails.wines.forEach(wine => {
                        if (wine.caseSize === 'n/a') {
                            isCollection = true;
                            return true
                        }
                    })
                }
                return isCollection
            },
            tradesListLength() {
                return this.tradesList.length
            },
            filteredItems() {
                let updatedListItems = [];

                this.tradesList.forEach(item => {
                    let invoiceItem = {};
                    invoiceItem.id = item.id;
                    invoiceItem.documentTypeId = item.documentTypeId;
                    invoiceItem.documentId = item.documentId === 0 ? '-' : item.documentId;
                    invoiceItem.date = moment(item.date).locale(this.$i18n.locale).format('DD MMMM YYYY');
                    invoiceItem.order = item.isBuy ? this.$i18n.t('buy') : this.$i18n.t('sell');
                    invoiceItem.invoiceType = item.type;
                    invoiceItem.type = item.type === 1 ? this.$i18n.t('bid') : (item.type === 2 ? this.$i18n.t('buy') : (item.type === 3 ? this.$i18n.t('bo-offer') : 'Sale'));
                    invoiceItem.quantity = item.quantity;
                    invoiceItem.wine = item.wine;
                    invoiceItem.service = this.formatPrice(item.servicesInclVat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));
                    invoiceItem.total = this.formatPrice(item.totalInclVat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));

                    if (item.status == 1) {
                        invoiceItem.status = 'Pending'
                    } else if (item.status == 2) {
                        invoiceItem.status = this.$i18n.t('trade-history11')
                    } else if (item.status == 3) {
                        invoiceItem.status = 'Edited'
                    } else if (item.status == 4) {
                        invoiceItem.status = this.$i18n.t('trade-history10')
                    } else if (item.status == 5) {
                        invoiceItem.status = this.$i18n.t('trade-history9')
                    } else if (item.status == 6) {
                        invoiceItem.status = 'Awaiting payment'
                    } else if (item.status == 7) {
                        invoiceItem.status = 'Initialising'
                    } else if (item.status == 8) {
                        invoiceItem.status = 'Processing payment'
                    } else {
                        invoiceItem.status = this.$i18n.t('trade-history8')
                    }

                    updatedListItems.push(invoiceItem);
                });

                return updatedListItems;
            },
            costDesc() {
                return this.SOInvoiceDetails.costs[0]
            },
            subtotal() {
                let amount = 0;
                this.SOInvoiceDetails.wines.forEach(element => {
                    amount += element.amount
                });
                return amount
            },
            total() {
                return this.subtotal - this.SOInvoiceDetails.costs[0].commissionAmountInclVAT - this.SOInvoiceDetails.costs[0].insuranceAmountInclVAT - this.SOInvoiceDetails.costs[0].storageAmountInclVAT
            }
        },
        methods: {
            ...mapActions({
                setInitialTrades: AOrders.GET_INITIAL_TRADES,
                getTrades: AOrders.GET_TRADES
            }),
            onBackButtonHandler() {
                this.showInvoice = false;
                this.showSOInvoice = false;
            },
            formatPrice(price) {
                return `€ ${price}`
            },
            formatInvoiceDate(date, isMonthly) {
                if (isMonthly) {
                    let formattedDate = new Date(date);
                    formattedDate.setDate(1);
                    formattedDate.setMonth(formattedDate.getMonth() - 1);
                    return moment(formattedDate).format('MMMM YYYY')
                } else {
                    return moment(date).locale(this.$i18n.locale).format('DD MMM YYYY');
                }
            },
            goToInvoiceDetails(invoice) {
                if (invoice.documentTypeId === 2) {
                    this.$store.dispatch(AOrders.GET_SALE_ORDER_DETAILS, invoice.documentId).then(() => {
                        this.showSOInvoice = true
                    });
                } else {
                    this.$store.dispatch(AUser.GET_INVOICE_DETAILS, {
                        invoiceId: [invoice.documentId],
                        invoiceType: invoice.documentTypeId
                    }).then(() => {
                        this.showInvoice = true
                    });
                }
            },
            downloadInvoicePDF() {
                this.$store.dispatch(AUser.GET_INVOICE_PDF, {
                    invoiceId: this.invoiceDetails.invoice.id,
                    invoiceType: this.invoiceDetails.invoiceType,
                    isGift: this.invoiceDetails.invoice.isGift,
                    userId: this.invoiceDetails.invoice.userId
                })
            },
            downloadSOInvoicePDF() {
                this.$store.dispatch(AOrders.GET_SALE_ORDER_PDF, {
                    invoiceId: this.SOInvoiceDetails.invoice.id,
                    userId: this.SOInvoiceDetails.invoice.userId
                })
            }
        },
        created() {
            this.setInitialTrades();
            this.getTrades(true);
        }
    }
</script>

<style scoped>
    .hyperlink-td {
        float: right;
    }

    .trades-history-wrapper {
        margin-bottom: 50px;
    }

    .wine-name {
        font-weight: 400;
    }

    .mobile-wines-header {
        margin-top: 30px;
        padding: 0 0 10px;
    }

    .mobile-wines-header div {
        color: #b2b2b2 !important;
        font-size: var(--fs-small);
        font-weight: 300;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        height: 20px;
        white-space: nowrap;
        display: inline-block;
        width: 33.33%;
    }

    .mobile-wines-row {
        padding: 15px 0;
        border-top: 1px solid #b2b2b2;
    }

    .mobile-wines-row:nth-child(even) {
        background: var(--semi-white);
    }

    .mobile-wines-div {
        display: inline-block;
        width: 33.33%;
        vertical-align: top;
        padding: 5px 0;
    }

    .mobile-wines-div.mobile-wines-div-row,
    .mobile-wines-header div.mobile-wines-div-row {
        width: 100%;
    }

    .mobile-wines-div .hyperlink-td {
        float: left;
    }

    .mobile-wines-div .link-border {
        height: 1px;
        width: 100%;
        background: #707070;
    }

    .mobile-wines-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-weight: 700;
        font-size: 25px;
        line-height: 30px;
        color: #303030;
        margin-top: 43px;
        margin-bottom: 38px;
    }

    .main-invoice-wrapper {
        margin-bottom: 50px;
    }

    .main-invoice-wrapper h2 {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-weight: 700;
        font-size: 25px;
        line-height: 30px;
        color: #303030;
        margin-top: 43px;
        margin-bottom: 38px;
    }

    .back-invoice {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 16px;
        font-weight: 300;
        color: #b2b2b2;
    }

    .back-invoice svg {
        fill: #b2b2b2;
        margin-left: 5px;
    }

    .back-invoice:hover {
        color: var(--brand);
        cursor: pointer;
    }

    .back-invoice:hover svg {
        fill: var(--brand);
    }

    .header-part {
        background: #03486F url('../assets/header.png') no-repeat center top;
        height: 42px;
        margin-bottom: 30px;
    }

    .download-pdf {
        display: inline-block;
        height: 32px;
        background-color: var(--blue);
        border: 1px solid var(--blue);
        color: #FFF;
        border-radius: 6px;
        line-height: 30px;
        min-width: 125px;
        text-align: center;
        padding-left: 30px;
        margin-top: 32px;
        margin-bottom: 32px;
        float: right;
        position: relative;
    }

    .download-pdf:hover {
        cursor: pointer;
    }

    .download-pdf svg {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 10px;
        top: 5px;
        color: #FFF;
        fill: #FFF;
    }

    .logo {
        background: url('../assets/logo_blue.png') no-repeat center;
        width: 282px;
        height: 80px;
        background-size: contain;
    }

    .header-info {
        height: 250px;
        margin: 40px 30px;
    }

    .header-info-left {
        width: 50%;
        display: inline-block;
        vertical-align: top;
    }

    .header-info-right {
        float: right;
        width: 300px;
        text-align: left;
        vertical-align: top;
    }

    .header-info-row {
        font-size: 18px;
        line-height: 25px;
    }

    .header-info-row span,
    .header-info-row strong {
        display: inline-block;
        margin-right: 10px;
        font-weight: 600;
        font-style: normal;
    }

    .header-info-row.vat {
        margin-top: 20px;
    }

    .table-wrapper {
        margin-top: 50px;
    }

    .table-header {
        font-size: 16px;
        font-weight: 600;
        border-bottom: 1px solid #B6B6B6;
        height: 40px;
    }

    .table-row {
        border-bottom: 1px solid #F6F7F7;
        height: 40px;
        line-height: 39px;
    }

    .table-row-details {
        height: 80px;
    }

    .container-invoice {
        width: 100%;
    }

    .sale-order-container .th,
    .sale-order-container .tr {
        width: 15%;
    }

    .th, .tr {
        width: 10%;
        float: left;
        line-height: 39px;
    }

    .th,
    .tr {
        text-align: right;
    }

    .th.th-first,
    .tr.tr-first {
        width: 50%;
        float: left;
        text-align: left;
    }

    .tr-first-wine-col {
        padding-left: 30px;
    }

    .th.th-first-monthly,
    .tr.tr-first-monthly {
        width: 40%;
        white-space: nowrap;
        text-align: left;
    }

    .th.th-reference,
    .tr.tr-reference {
        width: 20%;
        float: left;
    }

    .table-wrapper2 .th.th-first,
    .table-wrapper2 .tr.tr-first {
        width: 60%;
    }

    .table-wrapper3 .th.th-first,
    .table-wrapper3 .tr.tr-first {
        width: 40%;
    }

    .subtotal-row {
        text-align: right;
        font-size: 20px;
        margin: 20px 0;
    }

    .no-margin-bottom {
        margin-bottom: 0;
    }

    .no-margin-top {
        margin-top: 0;
    }

    .subtotal-row2 {
        text-align: right;
        font-size: 25px;
        margin: 35px 0;
    }

    .subtotal-row3 {
        text-align: right;
        font-size: 20px;
        margin: 5px 0;
    }

    .subtotal-row span, .subtotal-row2 span {
        font-weight: 600;
        display: inline-block;
        margin-left: 10px;
    }

    .vat-info {
        margin-top: 150px;
        margin-bottom: 30px;
        text-align: right;
    }

    .footer {
        border-top: 1px solid #B1B1B1;
        padding: 40px 0 20px;
        font-size: 16px;
    }

    .footer-left {
        width: calc(100% - 275px);
        display: inline-block;
    }

    .footer-right {
        width: 270px;
        padding-top: 50px;
        display: inline-block;
        vertical-align: top;
        text-align: right;
    }

    .footer-bold {
        font-weight: 600;
    }

    .footer-row-buy-wine {
        padding: 5px 15px;
        border: 1px solid #02486f;
        color: #02486f;
        margin-bottom: 12px;
        display: inline-block;
    }

    .table-row-desc,
    .tr-first-wine {
        font-weight: bold;
    }

    .invoice-details-wrapper .container-invoice {
        background-color: #FFFFFF;
    }

    @media (max-width: 767px) {
        .no-data {
            margin-top: 50px;
            text-align: center;
            font-size: 16px;
        }

        .container-invoice {
            padding: 0;
        }

        .logo {
            margin: 0 auto;
        }

        .header-info {
            height: auto;
            margin: 15px;
        }

        .header-info-left,
        .header-info-right {
            width: 100%;
            float: none;
        }

        .header-info-right {
            margin-top: 20px;
        }

        .footer-left,
        .footer-right {
            display: block;
            width: 100%;
        }

        .footer-right {
            text-align: center;
        }

        .footer {
            padding: 40px 15px 20px;
        }

        .table-header,
        .table-row-details,
        .table-row {
            height: auto;
        }

        .th, .tr,
        .table-wrapper3 .th.th-first,
        .table-wrapper3 .tr.tr-first {
            width: 50%;
            text-align: left;
            padding-left: 5px;
            float: none;
            display: inline-block;
            line-height: 25px;
            font-weight: normal;
        }

        .tr.tr-first,
        .th.th-first,
        .th.th-first-monthly,
        .tr.tr-first-monthly {
            width: 100%;
            padding-left: 5px;
        }

        .mobile-bold {
            font-weight: bold;
            margin-top: 30px;
            border-bottom: 1px solid #B6B6B6;
            border-top: 1px solid #B6B6B6;
        }

        .subtotal-row3 {
            padding: 20px 0;
            border-top: 1px solid #B6B6B6;
        }

        .subtotal-row2 {
            border-bottom: 1px solid #B6B6B6;
            border-top: 1px solid #B6B6B6;
            padding: 25px 0;
            margin-top: 0;
        }

        .monthly-details {
            padding: 0 15px;
        }

        .vat-info {
            margin-top: 50px;
            text-align: left;
            padding: 0 15px;
        }

        .invoice-details-wrapper {
            position: relative;
        }

        .back-invoice {
            top: 0;
        }

        .table-row-desc,
        .tr-first-wine {
            line-height: 20px;
            padding-left: 5px;
            margin-top: 15px;
        }
    }
</style>
